module.exports = __webpack_public_path__ + "img/custom.71c529ef.png";